import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { Level } from "../lib/stats";

/**
 * What the cross-section is currently plotting.
 *
 * The axes and the geography are one question, not three — changing the level
 * has to keep the axes if they exist there — so they live together. Log scaling
 * is remembered per axis rather than per measure, because it is a property of
 * how you want to look at the plot, not of the measure.
 */
interface StatsState {
  level: Level;
  x: string;
  y: string;
  logX: boolean;
  logY: boolean;
  /** Restrict the cross-section to one department, or "all". */
  dep: string;
  /** Drop zones whose price rests on fewer than this many recorded sales. */
  minSales: number;
  setLevel: (level: Level) => void;
  setX: (x: string) => void;
  setY: (y: string) => void;
  setLogX: (on: boolean) => void;
  setLogY: (on: boolean) => void;
  setDep: (dep: string) => void;
  setMinSales: (n: number) => void;
}

export const useStatsStore = create<StatsState>()(
  persist(
    (set) => ({
      // Heat island against price is the pair this pane was built for, and it
      // is the one that shows something the market has not obviously priced.
      level: "commune",
      x: "heat_night",
      y: "price_m2",
      logX: false,
      logY: true,
      dep: "all",
      minSales: 0,
      setLevel: (level) => set({ level }),
      setX: (x) => set({ x }),
      setY: (y) => set({ y }),
      setLogX: (logX) => set({ logX }),
      setLogY: (logY) => set({ logY }),
      setDep: (dep) => set({ dep }),
      setMinSales: (minSales) => set({ minSales }),
    }),
    { name: "mete-stats", version: 1 },
  ),
);
